import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { simpleDate } from "../config/dateFormatting"
import { DATE_QUERY_PARAM } from "../constants/constants"
import { useQuery } from "./useQuery"

export function useAdminDateQueryParam(date: Date, setDate: React.Dispatch<React.SetStateAction<Date>>){
    let queryParams = useQuery()
    let history = useHistory()
    
    useEffect(() => {
        let dateParam = queryParams.get(DATE_QUERY_PARAM)
        if(dateParam !== null){
            setDate(new Date(dateParam))
        }
    },[])

    /* Update local date if global different than today */
    useEffect(() => {
        if(date){
            let dateParam = queryParams.get(DATE_QUERY_PARAM)
            if(dateParam && dateParam !== simpleDate(date)){
                history.push({
                    pathname: history.location.pathname,
                    search: DATE_QUERY_PARAM + "=" + simpleDate(date)
                })
            } else {
                history.push({
                    pathname: history.location.pathname,
                    search: DATE_QUERY_PARAM + "=" + simpleDate(date)
                })
            }           
        }
    },[date])
}